import { useEffect } from 'react';

const GoogleFontLoader = ({ font }) => {
  useEffect(() => {
    const link = document.createElement('link');
    link.href = `https://fonts.googleapis.com/css?family=${encodeURIComponent(font)}&display=swap`;
    link.rel = 'stylesheet';
    
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [font]);

  return null;
};

export default GoogleFontLoader;